import { create } from 'zustand'

import { toast } from '@/shared/lib/toast'

import * as vendorApi from '../api/vendor.api'

export const useVendorStore = create((set, get) => ({
  vendors: [],
  isLoading: false,
  isSubmitting: false,
  error: null,

  fetchVendors: async () => {
    set({ isLoading: true, error: null })

    try {
      const result = await vendorApi.getVendors()

      set({
        vendors: result.data ?? [],
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to fetch vendors'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  createVendor: async (payload) => {
    if (get().isSubmitting) return null

    set({ isSubmitting: true, error: null })

    try {
      const result = await vendorApi.createVendor(payload)

      toast.success(result.message || 'Vendor created successfully')
      await get().fetchVendors()

      set({ isSubmitting: false, error: null })

      return result
    } catch (error) {
      const message = error.message || 'Failed to create vendor'

      set({
        isSubmitting: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  updateVendor: async (vendorId, payload) => {
    if (get().isSubmitting) return null

    set({ isSubmitting: true, error: null })

    try {
      const result = await vendorApi.updateVendor(vendorId, payload)

      toast.success(result.message || 'Vendor updated successfully')
      await get().fetchVendors()

      set({ isSubmitting: false, error: null })

      return result
    } catch (error) {
      const message = error.message || 'Failed to update vendor'

      set({
        isSubmitting: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  deleteVendor: async (vendorId) => {
    if (get().isSubmitting) return null

    set({ isSubmitting: true, error: null })

    try {
      const result = await vendorApi.deleteVendor(vendorId)

      toast.success(result.message || 'Vendor deleted successfully')
      await get().fetchVendors()

      set({ isSubmitting: false, error: null })

      return result
    } catch (error) {
      const message = error.message || 'Failed to delete vendor'

      set({
        isSubmitting: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },
}))
